﻿import * as React from "react";
import { IBaseSectionProps } from "./IBaseSectionProps";

export const TenancySection: React.FunctionComponent<IBaseSectionProps> = (
    props,
): React.ReactElement => (
    <div className={`tab-section`}>
        <a href={`/Tenancy`} target={`_self`}>
            <img
                alt={props.name}
                src={`/Images/Icon?icon=${props.moduleID}&folder=Module`}
            />
        </a>
    </div>
);
